// src/component/items/MemberItem.js
import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const MemberItem = ({ members }) => {
  const navigate = useNavigate();

  const handleClick = async (userId) => {
    const token = localStorage.getItem("token");
        const loggedInUserId = localStorage.getItem("user_id");


    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_MAIN_SITE_URL}/user/has-plan`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      

      if (res.data?.has_plan || loggedInUserId === userId) {
        // alert("You are already a member")
        navigate("/profile", { state: { userId } });
      } else {
        navigate("/pricing", { state: { from: { pathname: "/profile", userId } } });
      }
    } catch (err) {
      console.error("Plan check failed", err);
      navigate("/pricing", { state: { from: { pathname: "/profile", userId } } });
    }
  };

  return (
    <>
      {members.map((val, i) => (
        <div className="col member-item-card" key={val.id || i}  onClick={() => handleClick(val.id)}>
          <div className="lab-item member-item style-1 style-2">
            <div className="lab-inner">
              <div className="lab-thumb">
                <img
                  src={val.imgUrl || "/assets/images/member/default.jpg"}
                  alt={val.imgAlt || "member"}
                />
              </div>
              <div className="lab-content">
                <h6>
                  <span
                    className="profile-link"
                    style={{ cursor: "pointer"}}
                    onClick={() => handleClick(val.id)}
                  >
                    {val.memName}
                  </span>
                </h6>
                <p>{val.memActive || "Active recently"}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default MemberItem;
